import script from "./domain-name.vue?vue&type=script&setup=true&lang=js"
export * from "./domain-name.vue?vue&type=script&setup=true&lang=js"

import "./domain-name.vue?vue&type=style&index=0&id=75f5d7bd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75f5d7bd"]])

export default __exports__